import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonContent, IonList, IonItem, IonInfiniteScroll, IonInfiniteScrollContent, IonHeader, IonFooter } from '@ionic/react';
import ReactDOM from 'react-dom';


import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { EnterPasswordModal } from './Modal_EnterPassword';
import { ExpenseDetailsModal } from './Modal_DetailData_Expense';

//import classes from './Modal_ViewModal.module.css';
import '../../../../css/qavaApp.css';

const Backdrop = props => {
    return <div className='backdrop'/>
};

export function ViewExpensesModal (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let [viewExpenses, setViewExpenses] = useState([]);

    let [expenseID, setExpenseID] = useState(null);
    let [totalAmount, setTotalAmount] = useState(null);

    let [showExpenseDetailsModal, setShowExpenseDetailsModal] = useState(false);

    useEffect(() => {



        if(props.openModal == true && startDate != null && endDate != null)
        {

            /*
            let formData = new FormData();
            formData.append('Tracker', '74002A');
            formData.append('user', acctID);
            formData.append('xStartDateRange', props.startDate.toISOString().substr(0, 10));
            formData.append('xEndDateRange', props.endDate.toISOString().substr(0, 10));
                

            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74002A',
                    user: acctID,
                    xStartDateRange: authenticatedMerchent_context.startDate,
                    xEndDateRange: authenticatedMerchent_context.endDate,
                    sessionID: sessionID,
    
                }),
            }

            
            let routePath;
            if(authenticatedMerchent_context.authenticated == 'T1')
            {
                routePath = 'hotel_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T2')
            {
                routePath = 'proService_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T3')
            {
                routePath = 'retail_merchantAcct_argsjqApp'
            }
        
            
        fetch(baseURL+routePath, requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');



                    setViewExpenses((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            expenseID: cols[0],
                            supplierName: cols[1],
                            supplierPhoneNumber: cols[2],
                            expenseDescription: cols[3],
                            dateLogged: new Date(cols[4]).toISOString().substr(0, 10),
                            unitAmount: parseFloat(cols[5]).toFixed(2),
                            quantity: cols[6],
                            totalAmount: parseFloat(cols[7]).toFixed(2),
                            paymentType: cols[8],
                            attachment: cols[9],
                        })
                    });
                } 
            })
        }
    }, [props.openModal]);


    function handleSearchInput(searchData, category) {

            setViewExpenses([]);

            if(searchData == '')
            {
                return;
            }

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74002A_search',
                    user: acctID,
                    xSearchData: searchData,
                    xSearchCategory: category,
                    sessionID: sessionID,
    
                }),
            }

            
            let routePath;
            if(authenticatedMerchent_context.authenticated == 'T1')
            {
                routePath = 'hotel_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T2')
            {
                routePath = 'proService_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T3')
            {
                routePath = 'retail_merchantAcct_argsjqApp'
            }
        
            
        fetch(baseURL+routePath, requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');



                    setViewExpenses((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            expenseID: cols[0],
                            supplierName: cols[1],
                            supplierPhoneNumber: cols[2],
                            expenseDescription: cols[3],
                            dateLogged: new Date(cols[4]).toISOString().substr(0, 10),
                            unitAmount: parseFloat(cols[5]).toFixed(2),
                            quantity: cols[6],
                            totalAmount: parseFloat(cols[7]).toFixed(2),
                            paymentType: cols[8],
                            attachment: cols[9],
                        })
                    });
                } 
            })
  }

    function deleteExpense(enteredPassword)
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', '74002D');
        formData.append('user', acctID);
        formData.append('xExpenseID', expenseID);
        formData.append('xEnterAdminPassword', enteredPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74002D',
                user: acctID,
                xExpenseID: expenseID,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,

            }),
        }

            let routePath;
            if(authenticatedMerchent_context.authenticated == 'T1')
            {
                routePath = 'hotel_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T2')
            {
                routePath = 'proService_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T3')
            {
                routePath = 'retail_merchantAcct_argsjqApp'
            }
        
            
        fetch(baseURL+routePath, requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function closeModalHandler(event) {

        setViewExpenses([]);
        props.closeModal(event);
    }
 
    function viewExpenseDetailsHandler(event) {


        setExpenseID(event[1]);
        setTotalAmount(event[2]);

        setShowExpenseDetailsModal(event[0]);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    function viewDeleteExpenseHandler(event) {


        setShowPasswordModal(event[0]);
        setExpenseID(event[1]);
    }

    function onSubmitPasswordHandler(event)
    {
        deleteExpense(event);
    }



    return (

        <React.Fragment> 
           
            {props.openModal == true ?
            (
                <div>
                {ReactDOM.createPortal(<Backdrop />, document.getElementById('backdrop-root'))}

                <IonModal isOpen={ props.openModal }>
                    <IonHeader className='appModalHeader'>
                        <h3> One-Time Expenses </h3>
                    </IonHeader>

                    <IonContent >
                        <IonGrid className='appGridContent'>
                            <IonRow>
                                <IonCol>
                                    <input type='text' placeholder='Search Description' onChange={(e) => handleSearchInput(e.target.value, 'description')}></input>
                                </IonCol>
                            </IonRow>
                            <IonRow >
                                    <IonCol size='3'> <h3> Supplier Name </h3> </IonCol>
                                    {/*<IonCol className='appGridCol' size='2'> <h3> Supplier Phone </h3> </IonCol>*/}
                                    {/*<IonCol className='appGridCol' size='3'> <h3> Expense Description </h3> </IonCol>*/}
                                    <IonCol size='3'> <h3> Date Logged </h3> </IonCol>
                                    <IonCol size='3'> <h3> Total Amount </h3> </IonCol>                                        
                                    <IonCol size='3'> <h3> Action </h3> </IonCol>
                            </IonRow>
                        {viewExpenses.map((detailData) =>   {
                            return (
                                    <IonRow key={detailData.expenseID}>
                                        <IonCol size='3'>{detailData.supplierName}</IonCol>
                                        {/*<IonCol className='appGridCol' size='2'>{detailData.supplierPhoneNumber}</IonCol>*/}
                                        {/*<IonCol className='appGridCol' size='3'>{detailData.expenseDescription}</IonCol>*/}
                                        <IonCol size='3'>{detailData.dateLogged}</IonCol>
                                        <IonCol size='3'>{detailData.totalAmount}</IonCol>
                                        <IonCol size='3'>

                                            <IonButton className='appListButton' onClick={() => viewExpenseDetailsHandler([true, detailData.expenseID, detailData.totalAmount])}> Details </IonButton>
                                            {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton className='appListButton' onClick={() => viewDeleteExpenseHandler([true, detailData.expenseID])}> Delete </IonButton>}
                                            {/*<IonButton class='gridResultColumnButton' onClick={() => setViewAttachemntModal(true)}> View Invoice</IonButton>*/}
                                    
                                        </IonCol>
                                    </IonRow>
                            )
                        }
                        )}
                        </IonGrid>

                        <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>

                       {showExpenseDetailsModal == true && <ExpenseDetailsModal openModal={ showExpenseDetailsModal } closeModal={() => setShowExpenseDetailsModal(false)} data={{
                                            expenseID: expenseID, 
                                            totalAmount: totalAmount,
                                            }}></ExpenseDetailsModal>}

                    </IonContent>

                    <IonFooter className='modal_footer_button_center'>
                        <IonButton onClick={() => closeModalHandler(false)}> Close </IonButton>
                    </IonFooter>

                </IonModal>            
            </div>
            ) : null }

        </React.Fragment>

    )
}